import { z } from 'zod';

import {
  EntityBaseSchema,
  EntityMetadataSchema,
  IdSchema,
  NonEmptyStringSchema,
  PythonicNameSchema,
  ReferenceSchema,
} from '../../base';

export const AttributeReferencesSchema = z.object({
  topics: ReferenceSchema,
  flowSteps: ReferenceSchema,
  noCodeSteps: ReferenceSchema,
});

export type AttributeReferences = z.infer<typeof AttributeReferencesSchema>;

export type AttributeReferenceKey = keyof AttributeReferences;

export const BaseAttributeSchema = z.object({
  name: PythonicNameSchema.describe(
    'Attribute name in snake_case. Referenced in prompts and topics via {{attr:name}} syntax.',
  ),
  references: AttributeReferencesSchema,
});

export const AttributeSchema = EntityBaseSchema.merge(BaseAttributeSchema)
  .extend({
    // No longer default(false) since root-state.ts enforces input-output symmetry
    archived: z.boolean().optional(),
  })
  .merge(EntityMetadataSchema);

export type Attribute = z.infer<typeof AttributeSchema>;

export const VariantAttributesValuesSchema = z.object({
  id: IdSchema, // variant id
  values: z.record(z.string(), z.string()),
});

export type VariantAttributesValues = z.infer<
  typeof VariantAttributesValuesSchema
>;

export const BaseVariantSchema = z.object({
  name: NonEmptyStringSchema.describe(
    'Display name for this deployment variant (e.g. a brand, location, or A/B test group).',
  ),
});

export const VariantSchema = EntityBaseSchema.merge(BaseVariantSchema)
  .extend({
    isDefault: z
      .boolean()
      .describe(
        'Whether this is the default variant. Exactly one variant must be default.',
      ),
  })
  .merge(EntityMetadataSchema);

export type Variant = z.infer<typeof VariantSchema>;
